// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__2F7PW","rows":"style_rows__3tQNI","row":"style_row__347Eh","subtitle":"style_subtitle__20eH4","grid":"style_grid__1TCJ9"};